export default __webpack_public_path__ + "static/media/5.cd44cd7c.jpg";